import { useInfiniteQuery, useMutation } from 'react-query';
import { Bank, ListBanksQuery } from './Banks.types';
import { listBanks, getBank } from './Banks.service';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';

export function useBanks(params?: ListBanksQuery, enabled = true) {
  const cache = queryClient.getQueryData(['banks', { ...params }]);

  return useInfiniteQuery(
    ['banks', { ...params }],
    ({ pageParam }) => {
      const req: ListBanksQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listBanks(req);
    },
    {
      onError(error) {
        notificationError(error);
      },
      enabled:
        enabled &&
        !cache &&
        hasPermissions([Authorities.REGISTER_BANK_ACCOUNT_VIEW_BANK]),
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useBankMutation() {
  return useMutation(
    async (id: number) => {
      const cache = queryClient.getQueryData<Bank>(['bank', id]);

      if (!!cache) return cache;

      return getBank(id);
    },
    {
      onError(error) {
        notificationError(error);
      },
    },
  );
}
